import { WithdrawDetail } from '@bz/wallet';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      title: 'Withdraw Details',
    },
  },
};

export default WithdrawDetail;
